import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmailTemplateSchema = withDefaults({
  type: 'email-template',
  fields: [
    {
      kind: 'attribute',
      name: 'templateId',
    },
    {
      kind: 'attribute',
      name: 'templateKey',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'skipSend',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'hasMany',
      name: 'customCompanyEmailTemplates',
      type: 'custom-company-email-template',
      options: {
        async: false,
        inverse: 'emailTemplate',
      },
    },
  ],
});

export default EmailTemplateSchema;
